import React from 'react';
import styles from './Devices.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../shared/Modal/Modal';
import DevicesModalContent from '../../shared/Modal/ModalContent/Devices/Devices';
import { changeAllDevicesModalProps } from '../../../store/actions/modals';
import { Tooltip } from '@material-ui/core';

const Devices = () => {
    const dispatch = useDispatch();
    const { isVisible } = useSelector(state => state.modals.allDevicesModal);

    return (
        <>
            <Modal isVisible={isVisible} width='476px' textAlign='center' contentPadding='50px 0'>
                <DevicesModalContent />
            </Modal>
            <Tooltip title={<span className={'d-block p-2 f-s-14'}>All Devices</span>}>
                <button
                    className={styles.devicesButton}
                    onClick={() => dispatch(changeAllDevicesModalProps({ isVisible: true }))}
                >
                    <i className='icon-device' />
                </button>
            </Tooltip>
        </>
    );
};

export default Devices;
